import { render, staticRenderFns } from "./communityBnetwork.vue?vue&type=template&id=6a02c434&scoped=true"
import script from "./communityBnetwork.vue?vue&type=script&lang=js"
export * from "./communityBnetwork.vue?vue&type=script&lang=js"
import style0 from "./communityBnetwork.vue?vue&type=style&index=0&id=6a02c434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a02c434",
  null
  
)

export default component.exports